import { MaskedNumber } from '@/modules/projects/components/Workbench/MaskedNumber'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import {
  GRID,
  LABEL_COLUMN,
  MEMBER_BAR_HEIGHT,
  MEMBER_ROW,
  MONTH_GAP,
  TIMELINE_COLUMN,
} from '@/modules/projects/components/Workbench/mapLayout'
import type { Highlight } from '@/modules/projects/components/Workbench/mapView'
import { readableName } from '@/modules/projects/components/Workbench/readableName'
import { cn } from '@/utils'
import { MemberMonth } from './MemberMonth'

interface MemberCardRowProps {
  lane: MapLane
  highlight: Highlight
  openStatementId: string | null
  onOpenSegment: (segmentId: number) => void
}

// One card under its primary: who holds it, and the months it spent in. The violet rule down the
// left joins the group to the card above it. Nothing here can be picked up or dropped on.
export const MemberCardRow = ({
  lane,
  highlight,
  openStatementId,
  onOpenSegment,
}: MemberCardRowProps) => {
  const owner = lane.account?.owner
  return (
    <div className={MEMBER_ROW} data-member-card={lane.label}>
      <div className={cn(LABEL_COLUMN, 'group-last/member:pb-8')}>
        <div className="ml-1 h-full border-l-2 border-violet-200 pb-3 pl-4 group-last/member:h-auto">
          <div className="text-[13px] font-medium leading-5">
            <MaskedNumber number={lane.account?.numbers[0] ?? ''} />
          </div>
          <div className="text-xs leading-4 text-ink-subtle">
            {owner ? readableName(owner) : 'Owner not printed'}
          </div>
        </div>
      </div>

      <div
        className={cn(
          TIMELINE_COLUMN,
          'space-y-1 pb-3 group-last/member:pb-11',
        )}
      >
        {lane.years.map((row) => (
          <div
            key={row.year}
            className={cn('grid items-center', MONTH_GAP)}
            style={{
              gridTemplateColumns: GRID,
              gridTemplateRows: MEMBER_BAR_HEIGHT,
            }}
          >
            <span className="text-[11px] tabular-nums text-ink-subtle">
              {row.year}
            </span>
            {row.cells.map((cell) =>
              cell.coverage ? (
                <MemberMonth
                  key={cell.monthIndex}
                  lane={lane}
                  month={cell.coverage}
                  monthIndex={cell.monthIndex}
                  highlight={highlight}
                  openStatementId={openStatementId}
                  onOpenSegment={onOpenSegment}
                />
              ) : null,
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
